import React, { Component } from "react";
import { connect } from 'react-redux';
import { Nav, NavItem, Button } from 'reactstrap';
import '../../css/MarketCompare.scss';
import CompareGreaterRegion from "../Common/CompareGreaterRegion";
import CompareMarketsListMobile from './CompareMarketsListMobile';
import goback from '../../images/close-icon.svg';

import { withRouter} from 'react-router-dom';
import RentCycleConstants from "../../constants/RentCycleConstants";

export class MarketCompareSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false, // this is used to MarketCompare screen
      showRentData: true, //this is used to display Rent Data accordion
      showRentCyclePositions: true, // this is used to display Historical Rent Cycle Positions accordion
      showKeySubmarkets: true, // this is used to display Key Submarkets accordion
      isShowSearchContainer: false
    }

  }

  onClose = (e) => {
    this.props.onClose && this.props.onClose(e);
  };

  goBack = (e) => {  
    //this.props.history.push(this.props.basepath +'/marketdetailmobile');
    this.props.history.goBack();
    };

  render() {

    return (
      <div className="main-container">
        {/* <div > */}
          <div className="compare-panel-header-title">
          
            {/* <NavItem > */}
              <p>{RentCycleConstants.ADD_COMPARISON_MARKET}</p>
              <img className="go-back-mobile" alt="back" src={'#{rentrackerappimages}#' + '/close-icon.svg'} onClick={this.goBack}/>
            {/* </NavItem> */}
          </div>
        {/* </div> */}
        {/* <br></br> */}
        {/* <p className="compare-panel-market-select">{RentCycleConstants.ADD_COMPARISON_SUB_TEXT}
        </p> */}
        {/* <br ></br> */}
        <div style={{ textAlign: 'left' }}>
          <CompareGreaterRegion></CompareGreaterRegion>
        </div>
        <br />
        <div>
          <CompareMarketsListMobile markets={this.props.comparemarketslist} onClose={this.onClose} showRightPanel={this.showRightPanel} hideAddCompareButton={this.hideAddCompareButton}></CompareMarketsListMobile>
        </div>
        <br ></br>
        {/* <div style={{ textAlign: 'center', marginBottom: '50px' }}> <Button className="mobile-cancel-button" onClick={this.goBack}>{RentCycleConstants.CANCEL}</Button></div> */}
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    comparemarketslist: state.comparemarketslist,
    marketquarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [],
    basepath: state.basepath
  };
};

export default withRouter(connect(
  mapStateToProps
)(MarketCompareSelection));
